// A cota de uso da IA da obra, lida no PONTO DE ENTRADA (planning-workspace): o cliente vê
// quantos usos restam antes de abrir o painel, e a abertura de uma proposta nova é
// recusada com o motivo quando a cota acabou. A cota é compartilhada por todos os usos da
// IA da obra (`GET .../ai/access`), então é a mesma leitura que o composer já faz.
import { useEffect, useState } from "react";

import { fetchAiAccess } from "../../ai/aiApi";

const IDLE = Object.freeze({ loaded: false, enabled: null, quota: null });

/** Cota esgotada: limitada E sem usos. Ilimitada ou desconhecida nunca bloqueia. */
export const quotaIsExhausted = (quota) =>
  quota?.unlimited === false && quota?.remaining === 0;

/** A frase do ponto de entrada, no vocabulário do composer. */
export const quotaNote = (quota) => {
  if (!quota) return null;
  if (quota.unlimited) return "Uso ilimitado";
  if (quota.remaining === 0) return "Cota utilizada neste período";
  return quota.remaining === 1
    ? "1 uso disponível"
    : `${quota.remaining} usos disponíveis`;
};

/**
 * Lê o acesso/cota da obra enquanto `active`. Troca de obra descarta a leitura anterior (o
 * estado volta a "não carregado" no mesmo efeito) e uma resposta de obra antiga nunca
 * sobrescreve a atual. Falha de leitura deixa a cota DESCONHECIDA, que não bloqueia nada: o
 * back-end é quem recusa de fato.
 */
const useAiQuota = (workId, active = true, reloadKey = 0) => {
  const [state, setState] = useState(IDLE);

  useEffect(() => {
    setState(IDLE);
    if (!workId || !active) return undefined;
    const controller = new AbortController();
    let current = true;
    fetchAiAccess(workId, { signal: controller.signal })
      .then((payload) => {
        if (!current) return;
        setState({
          loaded: true,
          enabled: payload?.enabled === true,
          quota: payload?.quota ?? null,
        });
      })
      .catch(() => {
        if (current) setState({ loaded: true, enabled: null, quota: null });
      });
    return () => {
      current = false;
      controller.abort();
    };
  }, [workId, active, reloadKey]);

  return state;
};

export default useAiQuota;
